var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 16,
    viewBox: "0 0 23 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.29012 15.9998H5.68321V7.75949L0.835938 4.12402V14.5457C0.835938 15.3503 1.4879 15.9998 2.29012 15.9998Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3164 15.9998H20.7095C21.5141 15.9998 22.1637 15.3479 22.1637 14.5457V4.12402L17.3164 7.75949",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3164 1.45831V7.75976L22.1637 4.12429V2.18539C22.1637 0.387063 20.1109 -0.638142 18.6736 0.440382",
    fill: "#FBBC04"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.68311 7.75945V1.45801L11.4998 5.82054L17.3165 1.45801V7.75945L11.4998 12.122",
    fill: "#EA4335"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.835938 2.18539V4.12429L5.68321 7.75976V1.45831L4.32597 0.440382C2.88633 -0.638142 0.835938 0.387063 0.835938 2.18539Z",
    fill: "#C5221F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmailIcon);
export default __webpack_public_path__ + "static/media/gmail-icon.950d13d107e865c043a81f2f7631c80c.svg";
export { ForwardRef as ReactComponent };